import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    loads: translate({ id: 'global.loads' }),
    more: translate({ id: 'global.more' }),
  }))

  return api
}
